import { SettingsPartsFragment } from "~/gql/graphql";
import { useLatestSettingsQuery } from "../../graphql/query";

type UseSettings =
  | {
      settings: SettingsPartsFragment;
      loading: false;
    }
  | { settings: undefined; loading: true };

export function useSettings(): UseSettings {
  const { data: settingsData } = useLatestSettingsQuery();

  const settings = settingsData?.findLatestSettings;

  if (settings) {
    return { settings, loading: false };
  }

  return { settings: undefined, loading: true };
}
